/**
 * Large-money readback — Save stays disabled until the user confirms the words.
 */
import { dollarsToWords, needsMoneyWordsConfirm } from '../../../../lib/dollarsToWords'

export default function MoneyWordsConfirm({
  dollars,
  confirmed,
  onConfirmedChange,
}: {
  dollars: number
  confirmed: boolean
  onConfirmedChange: (v: boolean) => void
}) {
  if (!needsMoneyWordsConfirm(dollars)) return null
  const words = dollarsToWords(dollars)
  return (
    <div className="cm-words-confirm" data-testid="cm-words-confirm">
      <p className="cm-words-readback" data-testid="cm-words-readback">
        Confirm: <strong>{words}</strong>
      </p>
      <label className="cm-words-check">
        <input
          type="checkbox"
          checked={confirmed}
          onChange={(e) => onConfirmedChange(e.target.checked)}
          data-testid="cm-words-checkbox"
        />
        Yes — that amount is correct
      </label>
    </div>
  )
}

export function saveEnabledForMoney(dollars: number, wordsConfirmed: boolean): boolean {
  if (!Number.isFinite(dollars) || dollars < 0) return false
  if (needsMoneyWordsConfirm(dollars)) return wordsConfirmed
  return true
}
